import { Navigate, Route, Routes } from 'react-router-dom';
import ProductForm from './product/ProductForm';
import { ProductsPage } from './product/ProductsPage';
import MenuPage from './menu/MenuPage';
import RecipePage from './recipe/RecipePage';
import WarehousePage from './warehouse/WarehousePage';
import HistoryPage from './history/HistoryPage';
import MenuTodayPage from './menuToday/MenuTodayPage';
import LoginPage from '../../login/LoginPage';
import RecipeForm from './recipe/RecipeForm';
import MenuDayRecipesForm from './menu/dayForm/MenuDayRecipesForm';
import UserSettingsPage from './userSettings/UsserSettingsPage';
import { RolesValidator } from '../../../validations/RolesValidator';
import { ROLE } from '../../../utils/ROLE';
import { PartnersPage } from './partners/PartnersPage';
import { EmployeesPage } from './employees/EmployeesPage';
import { RememberPassword } from '../../rememberPassword/RememberPassword';
import { ConsumedProductsPage } from './reports/consumedProducts/ConsumedProductsPage';
import { OrdersPage } from './orders/OrdersPage';
import { HomePage } from './home/HomePage';

const Pages = () => {

    const toLogin = () => {
        return (
            <Navigate
                to={{
                    pathname: '/login',
                }}
            />
        );
    };
    return (
        <div className={'main-content-container'}>
            <Routes>
                <Route path='/login' element={<LoginPage />} />
                <Route path='/remember-password' element={<RememberPassword />} />
                <Route path='/' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.CULINARY, ROLE.MANAGER])
                        ? <HomePage />
                        : toLogin()
                } />
                <Route path='/menu' element={
                    RolesValidator([ROLE.DIETIST])
                        ? <MenuPage />
                        : toLogin()
                } />
                <Route path='/editDay' element={
                    RolesValidator([ROLE.DIETIST])
                        ? <MenuDayRecipesForm />
                        : toLogin()
                } />
                <Route path='/todayMenu' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.CULINARY, ROLE.MANAGER])
                        ? <MenuTodayPage />
                        : toLogin()
                } />
                <Route path='/recipe' element={
                    RolesValidator([ROLE.DIETIST])
                        ? <RecipePage />
                        : toLogin()
                } />
                <Route path='/recipeForm' element={
                    RolesValidator([ROLE.DIETIST])
                        ? <RecipeForm />
                        : toLogin()
                } />
                <Route path='/ProductsPage' element={
                    RolesValidator([ROLE.DIETIST])
                        ? <ProductsPage />
                        : toLogin()
                } />
                <Route path='/product' element={
                    RolesValidator([ROLE.DIETIST])
                        ? <ProductForm />
                        : toLogin()
                } />
                <Route path='/warehouse' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.MANAGER])
                        ? <WarehousePage />
                        : toLogin()
                } />
                <Route path='/orders' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.MANAGER])
                        ? <OrdersPage />
                        : toLogin()
                } />
                <Route path='/history' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.MANAGER])
                        ? <HistoryPage />
                        : toLogin()
                } />
                <Route path='/partners' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST])
                        ? <PartnersPage />
                        : toLogin()
                } />
                <Route path='/employees' element={
                    RolesValidator([ROLE.DIRECTOR])
                        ? <EmployeesPage />
                        : toLogin()
                } />
                <Route path='/consumed-products' element={
                    RolesValidator([ROLE.DIETIST, ROLE.MANAGER, ROLE.DIRECTOR])
                        ? <ConsumedProductsPage />
                        : toLogin()
                } />
                <Route path='/preferences' element={
                    RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.CULINARY, ROLE.MANAGER])
                        ? <UserSettingsPage />
                        : toLogin()
                } />
            </Routes>
        </div>

    );
};

export default Pages;
